import axios from "axios";
import { API_URL_VERSION } from "constants/environment";
import { KEYS } from "constants/keys";
import { ROUTES } from "constants/routes-path";

const api = axios.create({
  baseURL: API_URL_VERSION,
});

// Request adapter for default headers and authorization
api.interceptors.request.use((config) => {
    const token = localStorage.getItem(KEYS.token);
    if (!(config.data instanceof FormData)) {
        config.headers[KEYS.contentType] = config.headers[KEYS.contentType] ?? "application/json";
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptors for default error handlers
api.interceptors.response.use((response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(KEYS.token);
      localStorage.removeItem(KEYS.user);
      window.location.href = `${ROUTES.login}?${KEYS.redirectTo}=${encodeURI(window.location.pathname)}`;
    }
    return Promise.reject(error);
  }
);

export default api;
